module.exports = __webpack_public_path__ + "img/add.731b55ca.png";